<template>
  <div class="autocomplete row">
    <b-form-group
      :class="inputClass"
      :label="inputLabel"
      :label-for="inputId"
      class="col-md-12 mb-0">
      <div>
        <b-form-input
          v-if="required"
          :id="inputId"
          v-model="searchInput"
          :disabled="disabled"
          :placeholder="placeholder"
          required
          autocomplete="off"
          type="text"
          @input="onChange();"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
        />
        <b-form-input
          v-else
          :id="inputId"
          v-model="searchInput"
          :disabled="disabled"
          :placeholder="placeholder"
          required
          autocomplete="off"
          type="text"
          @input="onChange();"
          @keydown.down="onArrowDown"
          @keydown.up="onArrowUp"
          @keydown.enter="onEnter"
        />
        <ul v-show="isOpen" id="autocomplete-elements" class="autocomplete-elements">
          <li v-for="(element, i) in elements" :key="i" :class="{ 'is-active': i === arrowCounter }"
              class="autocomplete-element" @click=setElement(element)>
            {{ element }}
          </li>
        </ul>
      </div>
    </b-form-group>
  </div>
</template>

<script>

export default {
  name: 'AutocompleteField',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    inputId: {
      type: String,
      required: true
    },
    inputLabel: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    inputClass: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    searchInput: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      isOpen: false,
      elements: [],
      arrowCounter: -1
    };
  },

  watch: {
    items: function (value, oldValue) {
      if (value.length !== oldValue.length) {
        this.elements = value.filter(item => item && item.trim());
      }
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },

  destroyed() {
    document.removeEventListener('click', this.handleClickOutside);
  },

  methods: {
    setElement(element) {
      this.searchInput = element
      this.isOpen = false
      this.emitChangeSelectedValue()
    },

    filterElements() {
      this.elements = this.items.filter((item) => {
        if (item && item.trim()) {
          return item.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1;
        }
        return false;
      });
    },

    onChange() {
      this.$emit('input', this.searchInput);
      this.filterElements()
      this.isOpen = this.elements.length > 0
      this.emitChangeSelectedValue()
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
        this.emitChangeSelectedValue()
      }
    },

    onArrowDown() {
      if (this.arrowCounter < this.elements.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter() {
      if (this.arrowCounter !== -1) {
        this.searchInput = this.elements[this.arrowCounter];
      } else {
        this.items.push(this.searchInput)
      }
      this.isOpen = false;
      this.arrowCounter = -1;
      this.emitChangeSelectedValue()
    },

    emitChangeSelectedValue() {
      this.$emit('elementValueChanged', this.searchInput);
    }
  }
};

</script>

<style>
.autocomplete {
  position: relative;
}

.autocomplete-elements {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  background: var(--main-white);
  position: fixed;
  z-index: 10;
  width: 20%;
}

.autocomplete-element {
  list-style: none;
  text-align: left;
  padding: 4px 10px;
  cursor: pointer;
}

.autocomplete-element.is-active,
.autocomplete-element:hover {
  background-color: var(--main-color);
  color: white;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/AutocompleteField.vue